import bFormRow from '../layout/form-row';

export default bFormRow;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form/form-row.js
// module id = 378
// module chunks = 1